module.exports = __webpack_public_path__ + "img/meterprepaid.c1476ec5.svg";